module.exports = __webpack_public_path__ + "static/media/thunderstorm-moon.47bfd927.svg";